import { useContext } from 'react';
import { NextPage } from 'next';;
import getConfig from 'next/config';

import LocaleContext from 'components/context/Locale';
import Button from 'components/layout/Button';
import Head from 'components/layout/Head';
import LayoutContainer from 'components/layout/LayoutContainer';
import LayoutDefault from 'components/modules/public/layouts/Default';

import StyledComponent from './styles';
import { Props } from './types';

const PublicPageWorkerPolicy: NextPage<Props> = () => {
    const localeContext = useContext(LocaleContext);
    const data = localeContext?.translations?.workerPolicy;
    const { publicRuntimeConfig } = getConfig();
    return (
        <>
            <Head {...data.meta} />
            <LayoutDefault>
                <StyledComponent className="public-page-company-policy">
                    <LayoutContainer {...data.content.layoutContainerProps}>
                        <p className="headline">
                            {data.content.title}
                        </p>
                        <p className="txt">
                            Aktualny regulamin obowiązuje od dnia 19 marca 2025 r.
                        </p>

                        <Button {...data.content.buttonProps} />

                        <p className="txt-small">
                            Regulamin obowiązujący od dnia 4 marca 2024 r. do dnia 18 marca 2025 r. znajdziesz <a className="link" target="_blank" href="https://praca50.plus/pdf/regulamin-pracownik-04.03.2024.pdf">tutaj</a>.
                        </p>
                        <p className="txt-small">
                            Regulamin obowiązujący od 5 stycznia 2023 r. do 3 marca 2024 r. znajdziesz <a className="link" target="_blank" href="https://praca50.plus/pdf/regulamin-pracownik-05.01.2023.pdf">tutaj</a>.
                        </p>
                        <p className="txt-small">
                            Regulamin obowiązujący do 4 stycznia 2023 r. znajdziesz <a className="link" target="_blank" href="https://praca50.plus/pdf/regulamin-pracownik-04.01.2023.pdf">tutaj</a>.
                        </p>

                           
                    </LayoutContainer>
                </StyledComponent>
            </LayoutDefault>
        </>
    );
};

export default PublicPageWorkerPolicy;
